import { connect } from 'react-redux'
import at from 'lodash/at'
import debounce from 'lodash/debounce'
import every from 'lodash/every'
import get from 'lodash/get'
import map from 'lodash/map'
import merge from 'lodash/merge'
import pick from 'lodash/pick'
import reduce from 'lodash/reduce'
import values from 'lodash/values'
import isEmpty from 'lodash/isEmpty'

import { replace, push } from 'react-router-redux'
import { fetchLocation } from '../../actions/locations'
import { searchAreasByLocation } from '../../actions/areas'
import {
  fetchContractsForLocation,
  downloadCSV,
  requestWorkTrackerReport,
  downloadWorkTrackerSingleServiceReport,
} from '../../actions/contracts'
import { fetchWorkTrackersForLocationWithFilters } from '../../actions/work-trackers'
import {
  setAreaTypeFilterForLocation,
  setSubLocationFilterForLocation,
  setServiceFilterForLocation,
  setAmountFilterForLocation,
  setDatePeriodFilterForLocation,
  setLastCleanedFilterForLocation
} from '../../actions/work-tracker-filters'
import {
  loadTechnicianWorkSummariesForLocationInContract
} from '../../actions/technician-work-summaries'
import {
  loadTechnicianServicingVersionsForLocationInContract
} from '../../actions/technician-servicing-versions'

import WorkTrackerDetails from '../../components/work-trackers/work-tracker-details'

const tabNames = [
  'summary',
  'rooms',
  'technicians'
]

function mapStateToProps (state, ownProps) {
  const id = ownProps.params.locationId
  const location = state.locations[id]
  const searchQuery = ownProps.location.query.search
  const contractId = get(state, `workTrackerFilters.${id}.contractId`)
  const contract = get(state, `contracts.${contractId}`)

  let contractProgress = 0
  let contractDates = 'Select a Contract'
  const contractedServices = get(state, `contracts.${contractId}.contractedServicesAsStrings`, [])

  const areaTypeId = get(state, `workTrackerFilters.${id}.areaTypeId`)
  const subLocationId = get(state, `workTrackerFilters.${id}.subLocationId`)
  const serviceIds = get(state, `workTrackerFilters.${id}.serviceId`)
  const sortId = get(state, `workTrackerFilters.${id}.sortingId`)

  const amountIds = get(state, `workTrackerFilters.${id}.amountIds`, []).sort()
  const amounts = at(state.workTrackerFilters.amount, amountIds || [])
  const amountString = amounts.map((amount) => amount.name).join(', ')

  const lastCleaned = get(state, `workTrackerFilters.${id}.lastCleaned`)

  const enableAmountAndSort = !serviceIds
  const enableAmount = !serviceIds || (serviceIds && serviceIds.length !== 1)
  const singleServiceSelected = serviceIds && serviceIds.length === 1

  const appliedFilters = {
    areaType: get(state, `areaTypes.${areaTypeId}.name`),
    subLocation: get(state, `subLocations.${subLocationId}.name`),
    service: map(at(state.services, serviceIds || []), 'name').join(', '),
    amount: amountString,
    lastCleaned: lastCleaned,
    datePeriod: get(state, `workTrackerFilters.${id}.datePeriod`)
  }

  const emptyFilters = every(
    values(appliedFilters), (val) => (
      typeof(val) === 'undefined' || val === ''
    )
  )


  if (contract) {
    const formattedStartDate = contract.startDate.format('MMM Do, YYYY')
    const formattedEndDate = contract.endDate.format('MMM Do, YYYY')

    contractDates = `${formattedStartDate} – ${formattedEndDate}`
    contractProgress = contract.progress
  }

  if (!location) return {
    appliedFilters
  }

  const areaPagination = get(state, `pagination.areasByLocation.${id}-${searchQuery}`, {})

  const workTrackers = at(state.workTrackers, location.workTrackers || [])
  const areas = at(state.areas, areaPagination.ids || [])
  const _technicianWorkSummaries = at(
    state.technicianWorkSummaries,
    location.technicianWorkSummaries || []
  )

  const technicianServicingVersions = pick(
    state.technicianServicingVersions,
    location.technicianServicingVersions || []
  )

  const tsTechnicianWorkSummaries = reduce(_technicianWorkSummaries, (r,n) => {
    r[n.technicianId] = n
    return r;
  }, {})

  const technicianWorkSummaries = values(
    merge(
      {},
      tsTechnicianWorkSummaries, technicianServicingVersions
  ));

  const selectedTab = tabNames.indexOf(ownProps.location.query.tab)

  const userType = get(state.auth, 'session.type')

  return {
    locationModel: location,
    workTrackers,
    hasMoreAreas: areaPagination.nextPageUrl,
    searchQuery,
    areas,
    technicianWorkSummaries,
    selectedTab,
    contractedServices,
    contractDates,
    contractId,
    contractProgress,
    appliedFilters,
    emptyFilters,
    singleServiceSelected,
    enableAmountAndSort,
    enableAmount,
    userType
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.locationId
  const searchQuery = ownProps.location.query.search

  // dispatch(fetchLocation(id, { include_property_average: true }))
  //   .then(() => dispatch(searchAreasByLocation({
  //     locationId: id,
  //     searchQuery,
  //     includeWorkTrackerFilters: true,
  //     nextPage: false
  //   })))
  //   .then(() => dispatch(fetchContractsForLocation(id)))
  //   .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
  //   .then(() => dispatch(loadTechnicianWorkSummariesForLocationInContract(id)))
  //   .then(() => dispatch(loadTechnicianServicingVersionsForLocationInContract(id)))

  dispatch(searchAreasByLocation({
    locationId: id,
    searchQuery,
    includeWorkTrackerFilters: true,
    nextPage: false
  }))

  dispatch(fetchLocation(id, { include_property_average: true }))
    .then(() => dispatch(fetchContractsForLocation(id)))
    .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
    .then(() => dispatch(loadTechnicianWorkSummariesForLocationInContract(id)))
    .then(() => dispatch(loadTechnicianServicingVersionsForLocationInContract(id)))

  // dispatch(fetchLocation(id, { include_property_average: true }))
  // dispatch(searchAreasByLocation({
  //   locationId: id,
  //   searchQuery,
  //   includeWorkTrackerFilters: true,
  //   nextPage: false
  // }))
  // dispatch(fetchContractsForLocation(id))
  // dispatch(fetchWorkTrackersForLocationWithFilters(id))
  // dispatch(loadTechnicianWorkSummariesForLocationInContract(id))
  // dispatch(loadTechnicianServicingVersionsForLocationInContract(id))

  return {
    onLoadNextPage () {
      dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: true
      }))
    },

    onTabSelect (tabIndex) {
      dispatch(replace({
        pathname: ownProps.location.pathname,
        query: {
          ...ownProps.location.query,
          tab: tabNames[tabIndex]
        }
      }))
    },

    onSearch (event) {
      debouncedSearch(dispatch, ownProps.location, event.target.value)
    },

    clearAreaTypeFilter () {
      dispatch(setAreaTypeFilterForLocation(id, undefined))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))

    },

    clearSubLocationFilter () {
      dispatch(setSubLocationFilterForLocation(id, undefined))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))

    },

    clearServiceFilter () {
      dispatch(setServiceFilterForLocation(id, undefined))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))
    },

    clearAmountFilter () {
      dispatch(setAmountFilterForLocation(id, undefined))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))
    },

    clearDatePeriodFilter () {
      dispatch(setDatePeriodFilterForLocation(id, undefined))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))
    },

    clearLastCleanedFilter () {
      dispatch(setLastCleanedFilterForLocation(id, undefined))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))
    },

    updateLastCleanedFilter (value) {
      dispatch(setLastCleanedFilterForLocation(id, value))
      .then(() => dispatch(fetchWorkTrackersForLocationWithFilters(id)))
      .then(() => dispatch(searchAreasByLocation({
        locationId: id,
        searchQuery,
        includeWorkTrackerFilters: true,
        nextPage: false
      })))
    },

    csvDownload (contractId) {
      dispatch(downloadCSV(contractId))
    },

    requestWorkTrackerReport (contractId) {
      dispatch(requestWorkTrackerReport(id, contractId))
    },

    downloadWorkTrackerSingleServiceReport (contractId) {
      dispatch(downloadWorkTrackerSingleServiceReport(id, contractId))
    },

    goToServicingVersions (contractId, technicianId) {
      // id = locationId
      dispatch(push({
        pathname: `/work-tracker/${id}/servicing-versions`,
        query: {
          technicianId,
          contractId
        }
      }))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkTrackerDetails)

const debouncedSearch = debounce((dispatch, location, searchQuery) => {
  dispatch(replace({
    pathname: location.pathname,
    query: {
      ...location.query,
      search: searchQuery
    }
  }))
}, 500)



// WEBPACK FOOTER //
// ./src/containers/work-trackers/work-tracker-details-container.js